import { render } from "./ProductSetShipping.vue?vue&type=template&id=488d8e69"
import script from "./ProductSetShipping.vue?vue&type=script&lang=js"
export * from "./ProductSetShipping.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__